<kendo-dialog *ngIf="dialogOpened && loaded" id="taskPriorityDialog"
  title="{{'CHANGE-PRIORITY' | translate}}: {{shortTaskName | truncate: 27}}" (close)="closeDialog()" [height]="250"
  [minWidth]="200" [width]="500">
  <div class="k-form-inline p-2">
    <label class="k-form-field">
      <span class="k-text-uppercase dark label-width">{{ 'PRIORITY' | translate }}<span class="k-text-uppercase dark"
          *ngIf="taskPriority.length <= 2"> ({{taskPriority[0].text | uppercase | translate}})</span></span>
      <kendo-switch attr.aria-label="{{ 'PRIORITY' | translate }} ({{taskPriority[0].text | uppercase | translate}})"
        *ngIf="taskPriority.length <= 2" id="urgentPriority" [(ngModel)]="urgentPriority" [onLabel]="'YES' | translate"
        [offLabel]="'NO' | translate"></kendo-switch>
      <kendo-combobox *ngIf="taskPriority.length > 2" required [data]="taskPriority" [(ngModel)]="priority"
        [ngModelOptions]="{standalone: true}" [textField]="'text'" [valueField]="'value'" style="width: 100%">
        <ng-template kendoComboBoxItemTemplate let-dataItem>
          <span innerHTML="{{ dataItem.text | uppercase | translate }}">
          </span>
        </ng-template>
      </kendo-combobox>
    </label>
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="closeDialog()">{{'CANCEL' | translate}}</button>
    <button appPreventClick kendoButton (click)="changePriority();"
      [disabled]="!task || (task && priority === undefined)">{{'SAVE' | translate}}</button>
  </kendo-dialog-actions>
</kendo-dialog>